export default function VoicingSelect({ label, acordeName, aberturas, onSelect }) {
  return (
    <div className="boxCampo">
      <label>{label}</label>
      <select className="inputSeletor" onChange={(e) => onSelect(acordeName, e.target.value)}>
        {aberturas.map((abertura, key) => (
          <option key={key} value={abertura}>
            {`abertura${key + 1} - intervalos (${abertura})`}
          </option>
        ))}
      </select>
    </div>
  );
}
